(() => {
  'use strict';
  document.querySelectorAll('[data-office-cup]').forEach(root => {
    if (root.dataset.ocReady) return;
    root.dataset.ocReady = 'true';
    const variants = JSON.parse(root.querySelector('[data-oc-variants]').textContent);
    const form = root.querySelector('form'), select = root.querySelector('[data-oc-variant]');
    const image = root.querySelector('.oc-main-image'), error = root.querySelector('[data-oc-error]');
    const submit = root.querySelector('[data-oc-submit]');
    function changeImage(src, alt) {
      if (!image || !src) return;
      image.removeAttribute('srcset'); image.src = src;
      image.alt = alt || 'Office coffee cup';
      root.querySelectorAll('[data-oc-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ocImage === src)));
    }
    root.querySelectorAll('[data-oc-image]').forEach(button => button.addEventListener('click', () => changeImage(button.dataset.ocImage, button.dataset.ocAlt)));
    select.addEventListener('change', () => {
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      root.querySelectorAll('[data-oc-price],[data-oc-sticky-price]').forEach(node => node.textContent = variant.price);
      submit.disabled = !variant.available;
      submit.firstChild.textContent = variant.available ? 'Add to cart' : 'Sold out';
      changeImage(variant.image);
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
    });
    form.addEventListener('submit', async event => {
      if (!window.fetch) return;
      event.preventDefault();
      if (submit.disabled || !form.reportValidity()) return;
      const variant = variants.find(v => String(v.id) === select.value);
      const quantity = Number(form.elements.quantity.value);
      if (!variant?.available || !Number.isInteger(quantity) || quantity < 1 || quantity > 10) return;
      submit.disabled = true; submit.setAttribute('aria-busy', 'true'); error.hidden = true;
      try {
        const response = await fetch(form.action + '.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({id: variant.id, quantity})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'This cup could not be added. Please try again.');
        location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (err) {
        error.textContent = err.message || 'This cup could not be added. Please try again.'; error.hidden = false;
        submit.disabled = false; submit.removeAttribute('aria-busy');
      }
    });
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if ('IntersectionObserver' in window) {
      if (!reduced.matches) {
        root.classList.add('oc-motion');
        const reveal = new IntersectionObserver(entries => entries.forEach(entry => {if (entry.isIntersecting) {entry.target.classList.add('oc-visible'); reveal.unobserve(entry.target);}}), {threshold: .08});
        root.querySelectorAll('[data-oc-reveal]').forEach(node => reveal.observe(node));
      }
      const sticky = root.querySelector('[data-oc-sticky]');
      new IntersectionObserver(entries => {sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;}, {threshold: 0}).observe(root.querySelector('.oc-hero'));
    }
    root.querySelectorAll('a[href^="#oc-buy"]').forEach(link => link.addEventListener('click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return; event.preventDefault(); target.scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth'});
      select.focus({preventScroll: true});
    }));
    const visual = root.querySelector('[data-oc-visual]');
    if (image && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      visual.addEventListener('pointermove', event => {
        if (reduced.matches) return;
        const rect = visual.getBoundingClientRect();
        image.style.transform = `perspective(1200px) rotateY(${((event.clientX - rect.left) / rect.width - .5) * 5}deg) rotateX(${((event.clientY - rect.top) / rect.height - .5) * -4}deg)`;
      });
      visual.addEventListener('pointerleave', () => {image.style.transform = '';});
    }
  });
})();
